import { Injectable } from '@angular/core';

import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AppConfig } from '../app.config';
import { throwError } from 'rxjs';
import { filter, map, catchError } from 'rxjs/operators';
import { HelpersService } from './helpers.service';
import { ErrorHandlerService } from './errorhandler.service';// Add this for error feedback
 
@Injectable({
  providedIn: 'root',
})
export class SalesService {
  private apiURL: string = '';
  private env: any;

  constructor(
    private http: HttpClient,
    private appConfig: AppConfig,
    private helpersService: HelpersService,
    private httpClient: HttpClient, 
    private errorHandler: ErrorHandlerService,// Add this for error feedback
  ) {
    this.env = this.appConfig.getEnvironmentNew();
    this.apiURL = this.appConfig.getEnvironment();
  }

  createSaleCommunnicationTemplate(partnerID: any, data: any) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .post(
        this.env.url +
          `/2021-01/partner/${partnerID}/Sales/Communication?code=${this.env.key}`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getSaleCommunnicationTemplate(partnerID) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
          `/2021-01/partner/${partnerID}/Sales/Communication?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getProductTypes(ID: string) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();

    return this.http
      .get(
        this.apiURL + '/api/Invoice/Partner/' + ID + '/ProductTypes',
        requestOptions,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getProductTags(ID: string) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();

    return this.http
      .get(
        this.apiURL + '/api/Invoice/Partner/' + ID + '/ProductTags',
        requestOptions,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }
}
